import { ImageContentGridImageBottom } from "../../../../modules/image-content-grid/components/ImageContentGridImageBottom/ImageContentGridImageBottom";
import { ImageContentGridImageTop } from "../../../../modules/image-content-grid/components/ImageContentGridImageTop/ImageContentGridImageTop";
import type { IImageContentGridBlockProps } from "./ImageContentGridBlock.props";

export const ImageContentGridBlock = (props: IImageContentGridBlockProps) => {
  if (!props.items?.length) {
    return null;
  }

  const variant = props.variant ?? "image-top";

  return variant === "image-bottom" ? (
    <ImageContentGridImageBottom {...props} />
  ) : (
    <ImageContentGridImageTop {...props} />
  );
};

ImageContentGridBlock.displayName = "Block::ImageContentGridBlock";
